import { useState } from "react";
import "./pages.css";

export default function Contact() {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  // SEND EMAIL
  const sendMessage = () => {

    if (!name || !email || !message) {

      alert("Please fill all fields ❌");

      return;
    }

    const subject =
      encodeURIComponent(
        `Contact Form Message From ${name}`
      );

    const body =
      encodeURIComponent(
        `
Name: ${name}

Email: ${email}

Message:
${message}
        `
      );

    window.location.href =
      `mailto:apple1@shopat1stop.com?subject=${subject}&body=${body}`;
  };

  return (

    <div className="page-container">

      <div className="contact-form-card">

        <h1>Contact Us</h1>

        <p className="contact-text">
          Need help? Send us a message and our support team will reply soon.
        </p>

        <input
          type="text"
          placeholder="Your Name"
          value={name}
          onChange={(e) =>
            setName(e.target.value)
          }
        />

        <input
          type="email"
          placeholder="Your Email"
          value={email}
          onChange={(e) =>
            setEmail(e.target.value)
          }
        />

        <textarea
          placeholder="Write your message..."
          value={message}
          onChange={(e) =>
            setMessage(e.target.value)
          }
        />

        <button onClick={sendMessage}>
          Send Message
        </button>

      </div>

    </div>
  );
}